<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="flex flex-row">
    <div class="flex min-w-[2px] flex-grow flex-col" *ngIf="!!dashboard">
      <div class="divide-s300 divide-y">
        <div></div>
        <div></div>
      </div>

      <div class="mt-6 w-full">
        <div class="flex flex-col">
          <div class="mr-5 flex min-h-[44px] flex-shrink-0 flex-grow flex-row">
            <div
              (click)="toggleFiltersPanel()"
              class="text-s1 mt-2 flex h-11 select-none flex-row items-start space-x-2 px-5 text-xl font-semibold"
              [ngClass]="{
                'cursor-pointer': dashboard.fields.length > 0,
                'cursor-default': dashboard.fields.length === 0
              }"
            >
              <div class="flex flex-row items-center space-x-2">
                <m-chevron-right-icon
                  *ngIf="!filtersIsExpanded && dashboard.fields.length > 0"
                ></m-chevron-right-icon>
                <m-chevron-down-icon
                  *ngIf="filtersIsExpanded && dashboard.fields.length > 0"
                ></m-chevron-down-icon>

                <div
                  class="h-6 w-6"
                  *ngIf="dashboard.fields.length === 0"
                ></div>

                <div> Parameters </div>
              </div>
            </div>

            <div class="ml-3 flex max-h-[270px] w-full flex-col overflow-auto">
              <div
                class="mr-5 mt-1 flex min-h-[64px] flex-row items-start"
                *ngIf="!filtersIsExpanded && dashboard.fields.length > 0"
              >
                <m-bricks
                  class="mb-5 flex max-h-[150px] max-w-max cursor-pointer flex-row items-start justify-start overflow-auto"
                  [extendedFilters]="dashboard.extendedFilters"
                  [isKeepBackgroundColor]="false"
                  (click)="toggleFiltersPanel()"
                ></m-bricks>
              </div>

              <div
                class="flex w-full flex-row"
                *ngIf="
                  filtersIsExpanded === true || dashboard?.fields.length === 0
                "
              >
                <button
                  type="button"
                  data-cy="dashboardAddFilterButton"
                  class="border-s400 text-s500 hover:bg-m0 h-11 flex-shrink-0 select-none rounded border px-4 py-2 text-base font-medium focus:outline-none"
                  (click)="addFilter()"
                  >Add Filter</button
                >

                <div class="min-h-[68px]"></div>

                <div
                  class="ml-7 mt-1 max-h-96 w-2 flex-1 overflow-auto"
                  *ngIf="
                    filtersIsExpanded === true && dashboard.fields.length > 0
                  "
                >
                  <m-dashboard-filters
                    [dashboard]="dashboard"
                  ></m-dashboard-filters>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-[3px] flex h-2 w-full flex-row shadow-md"></div>

  <div class="flex h-2 flex-1 flex-row overflow-y-auto">
    <div class="flex min-w-[2px] flex-grow flex-col" *ngIf="!!dashboard">
      <div
        class="overflow-overlay flex h-full min-w-[2px] flex-grow flex-col"
        [ngClass]="{
          'pl-5': showDashboardsLeftPanel === true
        }"
      >
        <div #scrollable class="mt-1 flex w-full flex-grow flex-col">
          <ng-scrollbar
            [orientation]="'auto'"
            [visibility]="'hover'"
            [appearance]="'compact'"
          >
            <div class="mb-[100px] mt-5 pr-0">
              <ktd-grid
                [ngClass]="{
                  invisible: isShow === false
                }"
                *ngIf="!!dashboard.tiles"
                [compactType]="compactType"
                [preventCollision]="preventCollision"
                [cols]="cols"
                [rowHeight]="rowHeight"
                [layout]="layout"
                [scrollableParent]="scrollable"
                [scrollSpeed]="scrollSpeed"
                (layoutUpdated)="onLayoutUpdated($event)"
                (resizeEnded)="onResizeEnded($event)"
                (dragStarted)="onDragStarted($event)"
                (dragEnded)="onDragEnded($event)"
              >
                <ktd-grid-item
                  class="group"
                  [transition]="null"
                  *ngFor="let item of layout; let i = index; trackBy: trackByFn"
                  [id]="item.id"
                >
                  <div
                    ktdGridDragHandle
                    class="drag-handle text-s500 invisible flex h-6 w-6 flex-shrink-0 items-center justify-center group-hover:visible"
                  >
                    <m-drag-icon></m-drag-icon>
                  </div>

                  <div class="h-full pb-6 pr-5">
                    <m-dashboard-tile-chart
                      *ngIf="isShow === true"
                      #chartRep
                      [title]="item.tile.title"
                      [tile]="item.tile"
                      [deleteFilterFn]="deleteFilterFnBindThis"
                      [dashboard]="dashboard"
                      [randomId]="randomId"
                      [mconfig]="item.tile.mconfig"
                      [query]="item.tile.query"
                      [showTileParameters]="showTileParameters"
                    ></m-dashboard-tile-chart>
                  </div>

                  <button
                    class="delete-handle hover:bg-m200 text-s500 invisible flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                    (click)="deleteTile(i)"
                  >
                    <m-trash-icon></m-trash-icon>
                  </button>

                  <!-- <div
                    *ngIf="
                      !!item.tile.mconfig &&
                      item.tile.mconfig.warnSelect.length > 0
                    "
                    class="warn-handle text-p500 flex h-8 w-8 flex-shrink-0 items-center justify-center"
                    tp="Warning: The selected fields [{{
                      item.tile.mconfig.warnSelect.join(', ')
                    }}] may use unsafe aggregations and produce incorrect results"
                    placement="left"
                  >
                    <m-exclamation-icon></m-exclamation-icon>
                  </div> -->

                  <div
                    ktdGridResizeHandle
                    class="resize-handle invisible flex h-11 w-12 flex-shrink-0 flex-row items-start justify-start group-hover:visible"
                  >
                    <m-resize-icon
                      class="rotate-resize-icon text-s500 ml-[6px] mt-[6px] flex h-6 w-6"
                    ></m-resize-icon>
                  </div>
                </ktd-grid-item>
              </ktd-grid>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showDashboardsLeftPanel$ | async"></div>
<div *ngIf="showTileParameters$ | async"></div>
<div *ngIf="dashboard$ | async"></div>
<div *ngIf="nav$ | async"></div>
<!-- <div *ngIf="isExplorer$ | async"></div> -->
<div *ngIf="alias$ | async"></div>
